export default "__VITE_ASSET__BZW3j_gl__"